import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { Link, Redirect } from "react-router-dom";
import "react-quill/dist/quill.snow.css";

import languages from "../../../data/languages";
import { addStaticPage } from "./requests/addStaticPage";
import { getStaticPages } from "./requests/getStaticPages";
import filterTypes from "../../../data/filter-types";

const Editor = {
  modules: {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ align: [] }, { list: "ordered" }, { list: "bullet" },
        { indent: "-1" }, { indent: "+1" }],
      ["link", "image", "video"],
      ["clean"]
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    }
  },
  formats: [
    "header", "font", "size", "align",
    "bold", "italic", "underline", "strike", "blockquote",
    "list", "bullet", "indent",
    "link", "image", "video"
  ]
};

const StaticPagesEdit = (props) => {
  const [saved, setSaved] = useState(false);
  const [id] = useState(props.match.params.id || false);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [path, setPath] = useState("");
  const [language, setLanguage] = useState(Object.keys(languages)[0]);

  const handleSubmit = async () => {
    const stateData = Object.assign({}, {
      id,
      content,
      title,
      path,
      language
    });

    if (!stateData.title || !stateData.content || !stateData.language || !stateData.path) {
      return;
    }

    const mainData = {
      ...stateData
    };
    if (!mainData.id) {
      delete mainData.id;
    }

    await addStaticPage(mainData);
    setSaved(true);
  };

  useEffect(() => {
    if (id) {
      getStaticPages(0, 1, undefined, [{
        fieldName: "id",
        fieldValue: id,
        searchOperation: filterTypes.EQUALS.value
      }], (response) => {
        if (response && response.length === 1) {
          setTitle(response[0].title || "");
          setPath(response[0].path || "");
          setLanguage(response[0].language || "");
          setContent(response[0].content || "");
        }
      })();
    }
  }, [id]);

  if (saved) {
    return <Redirect to="/static-pages"/>;
  }

  return (
    <div className="w-100 p-2">
      <h1>Static page</h1>
      <div className="form-group">
        <label>Language</label>
        <select className="form-control" name="language" value={language} onChange={ev => setLanguage(ev.target.value)}>
          {Object.keys(languages)
            .map(item => (
              <option key={item} value={item}>{languages[item]}</option>
            ))}
        </select>
      </div>
      <div className="form-group">
        <label>Title</label>
        <input
          className="form-control"
          type="text"
          value={title}
          name="title"
          placeholder="Title"
          onChange={ev => setTitle(ev.target.value)}
          required={true}
        />
      </div>
      <div className="form-group">
        <label>Path</label>
        <input
          className="form-control"
          type="text"
          value={path}
          name="path"
          placeholder="Path. for example for privcy page it can be privacy_policy, or just privacy"
          onChange={ev => setPath(ev.target.value)}
          required={true}
        />
      </div>
      <div className="form-group mb-2">
        <label>Content</label>
        <ReactQuill
          modules={Editor.modules}
          formats={Editor.formats}
          theme="snow"
          value={content}
          onChange={setContent}
        />
      </div>
      <hr/>
      <div className="text-right mt-2">
        <Link
          className="btn btn-danger mr-2"
          to="/static-pages"
        >
          Cancel
        </Link>
        <button
          className="btn btn-success"
          onClick={handleSubmit}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default StaticPagesEdit;



// WEBPACK FOOTER //
// ./src/views/pages/static-pages/StaticPagesEdit.js